import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-missouri-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./missouri-state-form.component.html",
  styleUrl: "./missouri-state-form.component.scss",
})
export class MissouriStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
